import axios from 'axios';
import env from './env'

export const refreshTokenInstance = axios.create({
    baseURL: env('VITE_SERVICE_ENDPOINT'),
    headers: {
      'Content-Type': 'application/json',
    },
});